import React, { useState, useEffect } from 'react';
import Modal, { SimpleModal } from 'src/app/components/Modal';
import { FiZap } from 'react-icons/fi';
import { ReactComponent as MedalSuccess } from 'src/app/images/icons/medal-success.svg';
import { ReactComponent as MedalWarning } from 'src/app/images/icons/medal-warning.svg';
import { useClient } from 'jsonapi-react';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { EffectCards } from 'swiper/modules';
import Flashcard from './Flashcard';

export default function FlashcardGuideModal(props) {
  const { show, onClose, flashcardData, onChangePercentage, percentage, flashcardsAccepted, update } = props;

  const client = useClient();
  const { t } = useTranslation();
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loopQuestions, setLoopQuestions] = useState([]);

  useEffect(() => {
    if (flashcardData) {
      // IDs das questões respondidas incorretamente
      const wrongAnswersIds = flashcardsAccepted?.filter(card => card['accepted-answer'] === false)?.map(card => card['flashcard-id']);

      // IDs das questões já respondidas (corretas ou não)
      const answeredIds = flashcardsAccepted?.map(card => card['flashcard-id']);

      // Filtra as questões: não respondidas OU respondidas incorretamente
      const filteredQuestions = flashcardData.filter(flash => {
        const notAnswered = !answeredIds.includes(flash.id);
        const answeredWrong = wrongAnswersIds.includes(flash.id);
        return notAnswered || answeredWrong;
      });

      setLoopQuestions(filteredQuestions.length > 0 ? filteredQuestions : flashcardData);
    }
  }, [flashcardData]);

  async function handleSubmitQuestion(question, knowAnswer, acceptedAnswer, answered) {
    setIsSubmitting(true);
    const currentFlashcardUserId = question.user_flashcard_id;
    const currentFlashcardId = question.id;

    // Verificar se já existe uma resposta para este flashcard
    const existingAnswer = flashcardsAccepted?.find(answer => answer['flashcard-id'] === currentFlashcardId);

    const answerAttributes = {
      'flashcard-id': currentFlashcardId,
      'know-answer': knowAnswer,
      'accepted-answer': acceptedAnswer,
      answered: answered
    };

    // Se já existe uma resposta, incluir o ID para editar
    if (existingAnswer?.id) {
      answerAttributes.id = existingAnswer.id;
    }

    const { data, error } = await client.mutate(
      `/user_flashcards/${currentFlashcardUserId}`,
      {
        'user-answer-flashcards-attributes': [answerAttributes]
      },
      { method: 'PUT' }
    );

    if (error) {
      setIsSubmitting(false);
      toast.error(t('toast.errorOnSendAnswerFlashCard'));
      return error;
    }

    setIsSubmitting(false);
  }

  useEffect(() => {
    setCurrentQuestion(0);
  }, []);

  const handleClose = () => {
    onClose();
  };

  return (
    <SimpleModal
      show={show}
      onClose={() => handleClose()}
      contentClassName="simple-modal__content--lg"
    >
      <div className="flashcard-modal-guide">
        {loopQuestions.length > 0 ? (
          <div className="flashcard-wrapper">
            <div className="flashcard-wrapper__inner">
              <div className="flashcard-wrapper__header">
                <h3 className="flashcard-wrapper__title">{t('flashCard.review')}</h3>
              </div>

              <Swiper
                slidesPerView={1}
                modules={[EffectCards]}
                effect="cards"
                noSwipingClass="my-no-swiping"
              >
                {loopQuestions.map((question, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <Flashcard
                        setCurrentQuestion={setCurrentQuestion}
                        currentQuestion={currentQuestion}
                        handleSubmitQuestion={handleSubmitQuestion}
                        question={question}
                        isSubmitting={isSubmitting}
                        questionsLength={loopQuestions.length}
                        setLoopQuestions={setLoopQuestions}
                        update={update}
                      />
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          </div>
        ) : (
          <div className="flashcard-success">
            <div className="flashcard-success__inner">
              <MedalSuccess className="flashcard-success__medal" />

              <h3 className="flashcard-success__title">{t('flashCard.successTitle')}</h3>

              <p className="flashcard-success__description">{t('flashCard.successDescription')}</p>

              <button
                className="btn btn--wide btn--primary"
                onClick={handleClose}
              >
                {t('flashCard.buttonReturnStudyPlan')}
              </button>
            </div>
          </div>
        )}
      </div>
    </SimpleModal>
  );
}
